/**
 * @file
 * Submission competition webform behaviors.
 */
(function (Drupal, once) {

  Drupal.behaviors.submissionCompetitionWebformProgressTracker = {
    attach: function attach(context) {
      const submissionCompetitionWebforms = once(
        "submissionCompetitionWebformProgressTracker",
        ".webform-submission-competition-submissions-red-form, .webform-submission-competition-submissions-indiv-form",
        context
      );

      submissionCompetitionWebforms.forEach(submissionCompetitionWebform => {
        const progress = submissionCompetitionWebform.querySelector(".webform-progress");
        const container = submissionCompetitionWebform.querySelector("#edit-container-00");

        if (progress && container) {
          container.insertAdjacentElement("afterend", progress);
        }

        submissionCompetitionWebform.classList.add("js-ready");

        if (!progress) return;

        const progressTrackerNextStepButton = progress.querySelector("li.progress-step[data-webform-page='krok_2']");
        const nextStepButtonBelowForm = submissionCompetitionWebform.querySelector("input.webform-button--next[value='Krok 2']");

        if (!progressTrackerNextStepButton || !nextStepButtonBelowForm) return;

        progressTrackerNextStepButton.addEventListener("click", () => {
          nextStepButtonBelowForm.click();
        });
      });
    }
  };

  function updateTitleAttributes(submissionCompetitionWebform) {
    const disabledInputs = submissionCompetitionWebform.querySelectorAll("[disabled][disabled-title]");

    disabledInputs.forEach(element => {
      const disabledTitleValue = element.getAttribute('disabled-title');
      if (disabledTitleValue) {
        element.setAttribute('title', disabledTitleValue);
      }
    });

    const notDisabledButHasDisabledTitle = submissionCompetitionWebform.querySelectorAll("[disabled-title]:not([disabled])");
    notDisabledButHasDisabledTitle.forEach(element => {
      element.removeAttribute('title');
    });

    return disabledInputs;
  }

  Drupal.behaviors.submissionCompetitionWebformDisabledTitle = {
    attach: function attach(context) {
      const submissionCompetitionWebforms = once(
        "submissionCompetitionWebformDisabledTitle",
        ".webform-submission-competition-submissions-red-form, .webform-submission-competition-submissions-indiv-form",
        context
      );

      submissionCompetitionWebforms.forEach(submissionCompetitionWebform => {
        updateTitleAttributes(submissionCompetitionWebform);

        const observer = new MutationObserver(function (mutations) {
          let shouldUpdate = false;

          mutations.forEach(function (mutation) {
            if (mutation.type === 'attributes') {
              const attributeName = mutation.attributeName;

              if (attributeName === 'disabled' || attributeName === 'disabled-title') {
                shouldUpdate = true;
              }
            }
          });

          if (shouldUpdate) {
            updateTitleAttributes(submissionCompetitionWebform);
          }
        });

        const config = {
          attributes: true,
          attributeOldValue: true,
          subtree: true,
          attributeFilter: ['disabled', 'disabled-title']
        };

        observer.observe(submissionCompetitionWebform, config);

        submissionCompetitionWebform._disabledInputsObserver = observer;
      });
    }
  };

  Drupal.behaviors.submissionCompetitionWebformSubmissionDescription = {
    attach: function attach(context) {
      const submissionCompetitionWebforms = once(
        "submissionCompetitionWebformSubmissionDescription",
        ".webform-submission-competition-submissions-red-form, .webform-submission-competition-submissions-indiv-form",
        context
      );

      submissionCompetitionWebforms.forEach(submissionCompetitionWebform => {
        const radioGroup = submissionCompetitionWebform.querySelectorAll("input[name='kategoria_zgloszenia']");
        const descriptionContainer = submissionCompetitionWebform.querySelector(".form-item-opis-pracy-konkursowej-pole-nieobowiazkowe");

        if (!radioGroup.length || !descriptionContainer) return;

        const label = descriptionContainer.querySelector("label.form-label");
        const textarea = descriptionContainer.querySelector("textarea.form-textarea");
        const description = descriptionContainer.querySelector("small.description div.webform-element-description");

        if (!label || !textarea || !description) return;

        const defaultLabel = label.textContent;
        const defaultDescription = description.textContent;
        const defaultMaxLength = textarea.maxLength;

        const fotoLabel = textarea.getAttribute("foto-label");
        const fotoDescription = textarea.getAttribute("foto-description");
        const fotoMaxLength = textarea.getAttribute("foto-max-length");

        const toggleDescription = () => {
          const isFotoSelected = Array.from(radioGroup).some(r => r.value === "2" && r.checked);

          label.textContent = isFotoSelected ? fotoLabel : defaultLabel;
          textarea.maxLength = isFotoSelected ? fotoMaxLength : defaultMaxLength;
          description.textContent = isFotoSelected ? fotoDescription : defaultDescription;
        };

        toggleDescription();

        for (const radio of radioGroup) {
          radio.addEventListener("change", toggleDescription);
        }
      });
    }
  };

  Drupal.behaviors.submissionCompetitionWebformSubmissionDateValidation = {
    attach: function attach(context) {
      const submissionCompetitionWebforms = once(
        "submissionCompetitionWebformSubmissionDateValidation",
        ".webform-submission-competition-submissions-red-form, .webform-submission-competition-submissions-indiv-form",
        context
      );

      submissionCompetitionWebforms.forEach(submissionCompetitionWebform => {
        const progressTrackerNextStepButton = submissionCompetitionWebform.querySelector(".webform-progress li.progress-step[data-webform-page='krok_2']");
        const nextStepButtonBelowForm = submissionCompetitionWebform.querySelector("input.webform-button--next[value='Krok 2']");

        const publicationDateRadios = submissionCompetitionWebform.querySelectorAll("input[name='czy_praca_byla_publikowana_w_okresie_od_15_sierpnia_2024_do_15_s']");
        const fotoPublicationDateRadios = submissionCompetitionWebform.querySelectorAll("input[name='czy_praca_byla_wykonana_w_okresie_od_15_sierpnia_2024_do_15_sier']");

        if (!progressTrackerNextStepButton || !nextStepButtonBelowForm || !publicationDateRadios.length || !fotoPublicationDateRadios.length) return;

        const checkDisabled = () => {
          // znajdź aktywną grupę – ta, która ma input nie-disabled i widoczny
          const activeGroup = Array.from(publicationDateRadios).some(r => !r.disabled && r.offsetParent !== null)
            ? publicationDateRadios
            : Array.from(fotoPublicationDateRadios).some(r => !r.disabled && r.offsetParent !== null)
              ? fotoPublicationDateRadios
              : [];

          const activeRadios = Array.from(activeGroup).filter(r => !r.disabled);
          const isDisabled = activeRadios.some(r => r.checked && r.value === "0");

          progressTrackerNextStepButton.style.pointerEvents = isDisabled ? "none" : "";
          progressTrackerNextStepButton.style.opacity = isDisabled ? "0.5" : "";
          nextStepButtonBelowForm.disabled = isDisabled;
        };

        // początkowa kontrola
        checkDisabled();

        // nasłuch zmian we wszystkich radio
        [...publicationDateRadios, ...fotoPublicationDateRadios].forEach(input => input.addEventListener("change", checkDisabled));

        // obserwator atrybutów disabled
        const observer = new MutationObserver(checkDisabled);

        [...publicationDateRadios, ...fotoPublicationDateRadios].forEach(input => {
          observer.observe(input, { attributes: true, attributeFilter: ['disabled'] });
        });

        // blokada kliknięcia w progress button
        progressTrackerNextStepButton.addEventListener("click", e => {
          if (nextStepButtonBelowForm.disabled) {
            e.stopImmediatePropagation();
            e.preventDefault();
          }
        });
      });

    }
  };
})(Drupal, once);
